import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: "root"
})
export class ClientesViewService {
  private url = `${environment.API}clientes`;

  constructor(private http: HttpClient) {}

  getclientess(clientes: String): Observable<any> {
    return this.http.post(this.url, {
      tiporeq: "C",
      cgc: clientes
    });
  }
}
